import React from 'react';
import { IView } from '@framework-controls/core';
import { ApptVeh, NewVehicle } from 'src/models';
import { VINEntryFlag } from 'src/enums';
import DesktopPane from '../DesktopPane/DesktopPane';

interface IProps {
    optionsSelected?: NewVehicle;
    vinSpecFlag: string;
    leftPaneViewOrder: IView[];
    selectedVehicle?: ApptVeh;
    updateVehicleMileage: (mileage: number) => void,
    prevMileage: string,
    theme: string,
    defaultLen: number,
    Itype: string | undefined;
    TMNAMileage: number,
}

const DesktopView = (props: IProps) => {
    const optionsSelected = props.optionsSelected!;
    const { leftPaneViewOrder, vinSpecFlag } = props;
    const selectedVehicle = props.selectedVehicle!;
    const { vin, vinValid } = optionsSelected;

    let showVin = VINEntryFlag.Hide;

    switch (vinSpecFlag) {
        case VINEntryFlag.Show:
            showVin = (!vinValid || vin === '' || !selectedVehicle?.make) ? VINEntryFlag.Show : VINEntryFlag.Hide;
            break;
        case VINEntryFlag.Require:
            showVin = (!vinValid && !selectedVehicle.make) ? VINEntryFlag.Require : VINEntryFlag.Hide;
            break;
        case VINEntryFlag.Hide:
        default:
            break;
    }

    return (
        <div id='desktopView'>
            <DesktopPane
                optionsSelected={optionsSelected}
                leftPaneViewOrder={leftPaneViewOrder}
                showVin={showVin}
                selectedVehicle={selectedVehicle!}
                updateVehicleMileage={props.updateVehicleMileage}
                prevMileage={props.prevMileage}
                theme={props.theme}
                defaultLen={props.defaultLen}
                Itype={props?.Itype}
                TMNAMileage={props.TMNAMileage}
            />
        </div>

    );
};
export default DesktopView;